module.exports = __webpack_public_path__ + "static/img/4.835bfd0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ment/4.png
// module id = BLPJ
// module chunks = 0